'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formData = require('form-data');

var _formData2 = _interopRequireDefault(_formData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Certificates = function () {
  function Certificates(base) {
    _classCallCheck(this, Certificates);

    this.base = base;
  }

  _createClass(Certificates, [{
    key: 'fetch',
    value: function fetch() {
      return this.base.get('/certificates');
    }
  }, {
    key: 'upload',
    value: function upload(file, params) {
      var data = new _formData2.default();
      Object.keys(params).forEach(function (k) {
        return data.append(k, params[k]);
      });
      data.append('certificate', file);
      return this.base.post('/certificates/upload', data);
    }
  }, {
    key: 'request',
    value: function request(data) {
      return this.base.post('/certificates/request', data);
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      return this.base.delete('/certificates/' + id);
    }
  }, {
    key: 'renew',
    value: function renew(id) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.base.post('/certificates/' + id + '/renew', data);
    }
  }]);

  return Certificates;
}();

exports.default = Certificates;